import moment from "moment";
import { IMatchDetailDTO } from "../../models/IMatch";
import { formatSideName } from "../../utils/methods";

/** One of the three upcoming / latest matches on the overview: when, round, the two sides and the sets, where. */
const OverviewMatchRow = ({ match, onOpen }: { match: IMatchDetailDTO; onOpen: () => void }) => {
  // After the result: the winner bold, the loser light
  const sideClass = (teamId?: string | null) =>
    match.isCompleted ? (match.winnerTeamId === teamId ? "bold" : "light") : "";
  const scoreClass = (teamId?: string | null) => (match.isCompleted && match.winnerTeamId === teamId ? "bold" : "");

  return (
    <div
      className="match-item"
      role="link"
      tabIndex={0}
      onClick={onOpen}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onOpen();
        }
      }}
    >
      <div className="time-round-container">
        <p className="time">{match.startTime ? moment(match.startTime).format("DD/MM/YYYY - hh:mm A") : "TBA"}</p>
        <p className="round">{match.round ?? "-"}</p>
      </div>
      <div className="score">
        <div className="score-left-section">
          <p className={`team-name ${sideClass(match.homeTeamId)}`}>
            {formatSideName(match.homeTeamName, match.homeTeam2Name, match.homeExtraUnits)}
          </p>
        </div>
        <div className="middle-section">
          <p className={`home-team-score ${scoreClass(match.homeTeamId)}`}>{match.isCompleted ? match.homeTeamSets : ""}</p>
          {match.isCompleted && <p className="vs">-</p>}
          <p className={`away-team-score ${scoreClass(match.awayTeamId)}`}>{match.isCompleted ? match.awayTeamSets : ""}</p>
        </div>
        <div className="score-right-section">
          <p className={`team-name ${sideClass(match.awayTeamId)}`}>
            {formatSideName(match.awayTeamName, match.awayTeam2Name, match.awayExtraUnits)}
          </p>
        </div>
      </div>
      <p className="venue">{match.venue ?? "-"}</p>
    </div>
  );
};

export default OverviewMatchRow;
